module.exports = __webpack_public_path__ + "static/media/cg.4ad6f3e8.svg";